import { render, staticRenderFns } from "./marketDetail.vue?vue&type=template&id=e00a18b0&scoped=true&"
import script from "./marketDetail.vue?vue&type=script&lang=js&"
export * from "./marketDetail.vue?vue&type=script&lang=js&"
import style0 from "./marketDetail.vue?vue&type=style&index=0&id=e00a18b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00a18b0",
  null
  
)

export default component.exports